import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function completeProfileReducer(
  state = initialState.completeProfile,
  action
) {
  switch (action.type) {
    case types.COMPLETE_PROFILE_REQUESTED:
      return {
        ...state,
        loading: true,
        error: {},
        success: false,
        successRegister: false,
      };
    case types.COMPLETE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        success: false,
        successRegister: true,
      };
    case types.COMPLETE_PROFILE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        success: false,
        successRegister: false,
      };
    case types.COMPLETE_PROFILE_SET_USER_DATA_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
    default:
      return state;
  }
}
